import React from "react";
import "../../assets/css/style.css";
import domtoimage from 'dom-to-image';

var downloadName="invitation.jpeg";

class CustomInvitation extends React.Component {
  constructor(props) {
    super(props);
    this.customDesign = props.reqObject.customDesign;
    this.venue = props.reqObject.venue;
    this.venueForMaps = this.venue.split(' ').join('+');
    this.venueAddress = props.reqObject.venueAddress;
    this.link = `https://www.google.com/maps/search/?api=1&query=${this.venueForMaps}`;
    this.changed = props.reqObject.changed;
    this.isSideBySide = props.isSideBySide;
    this.baseSong = props.reqObject.baseSong;
    this.reqObject = props.reqObject
    
  }
 
  
  isupdate = 0;
  componentWillUpdate() {
    if (this.isSideBySide) {
      this.venue = this.props.reqObject.venue;
      this.venueForMaps = this.venue.split(' ').join('+');
      this.venueAddress = this.props.reqObject.venueAddress;
      this.link = `https://www.google.com/maps/search/?api=1&query=${this.venueForMaps}`;
    this.customDesign = this.props.reqObject.customDesign;
      this.changed = this.props.reqObject.changed;
      this.isSideBySide = this.props.isSideBySide;
     if(this.isupdate===0)
     {
      this.setState((prevState, props) => ({
        changed: !this.changed
      }));
      this.isupdate++;
     }
     else
      {
        this.isupdate=0;
      }
    }
  }
  
  RSVP() {
    if (this.props.isSideBySide) {
      window.alert("RSVP will be available once payment has been made.")
    }
    else
    {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('documentId');
      window.location.href = "/RSVP?documentId=" + myParam;    }
  }

  DownloadPdf() {
    if(this.props.isSideBySide)
    {
      window.alert("Downloading Document will be available once payment has been made.")
    }
    else
    {
    window.scrollTo(0, 0)
    
    document.getElementById("download-button").style.display = "none";
    document.getElementById("directions-button").style.display = "none";
        document.getElementById("RSVPButton").style.display = "none";
    var node = document.getElementById('fullInvite');
    
    downloadName= this.props.womanName + '_and_' + this.props.manName + `'s_Wedding.jpeg`;

    domtoimage.toJpeg(node,{ quality: 1 })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = downloadName;
        link.href = dataUrl;
        link.click();
      }).then(function() {
        document.getElementById("download-button").style.display = "block";
        document.getElementById("directions-button").style.display = "block";
        document.getElementById("RSVPButton").style.display = "block";
      })
      .catch(function (error) {
          console.error('oops, something went wrong!', error);
      }).then(function() {
        document.getElementById("download-button").style.display = "block";
        document.getElementById("directions-button").style.display = "block";
        document.getElementById("RSVPButton").style.display = "block";
      });
    }
  }
componentDidMount()
{
  console.log(this.reqObject)
  if(this.reqObject.allowRsvp==='true')
  {
    document.getElementById('RSVPButton').style.display = 'block'
  }
}
  render() {
    var bodyStyle = this.isSideBySide? "body-style-regular-wedding":"body-style-custom-wedding";
    return (
      <div id="fullCard" style={{margin:"auto"}} className={bodyStyle} >
        <img style={{maxHeight: "90vh",width:"auto"}} alt='customImage' id='customImage' src = {this.customDesign}/>
        <div className='row' style={{margin:0,alignItems:"center",justifyContent:"center"}}>
          <a href={() => false} onClick={() => this.RSVP()} style={{ cursor: 'pointer' , display:"none"}} id = "RSVPButton">
            <div className="venue-wedding" style={{ backgroundColor: "#1DAEE0" }} ><b>RSVP</b></div>
          </a>
          <a href={this.link} target="_blank" rel="noopener noreferrer" id="directions-button">
            <div className="venue-wedding" style={{ backgroundColor: "#1DAEE0" }}><b>DIRECTIONS</b></div>
          </a>
          <a href={() => false} onClick={() => this.DownloadPdf()} style={{ cursor: 'pointer' }} id="download-button">
            <div className="venue-wedding downloadButton-wedding" style={{ backgroundColor: "#1DAEE0" }} ><b>DOWNLOAD</b></div>
          </a>
        </div>
        <div>
          {this.isSideBySide ?
            null :
            <audio className="audio-element"  src={this.baseSong}>
            </audio>
          }
        </div>
      </div>
    );
  }
}

export default CustomInvitation;